module.exports = __webpack_public_path__ + "static/media/pattern-3.b2893460.svg";